// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../node_modules/css-loader/index.js??ref--5-1!../../../../../node_modules/postcss-loader/lib/index.js??ref--5-2!./material-design-iconic-font.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("66e19f80", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/mdi-font/css/material-design-iconic-font.min.css
// module id = 11Zf
// module chunks = 2